/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrServiceUserEntity } from './irrServiceUserEntity';
import { IrrServiceUserType } from './irrServiceUserType';


/**
 * IRR SaaS Config ServiceUser
 */
export interface IrrServiceUser { 
    entity?: IrrServiceUserEntity;
    type?: IrrServiceUserType;
    /**
     * service user principal
     */
    principal?: string;
}
export namespace IrrServiceUser {
}


